import { MergedAvailabilities } from 'types'

export function getSpecialistFirstAvailability({
  availabilities,
  specialistId,
}: {
  availabilities: MergedAvailabilities
  specialistId: string
}) {
  const match = Object.entries(availabilities)
    .sort(([a], [b]) => a.localeCompare(b))
    .flatMap(([, items]) => {
      return items.filter((singleItem) => {
        return singleItem.resource_ids.includes(specialistId)
      })
    })[0]
  return match
    ? { date_start: match.date_start.getTime(), resource_ids: match.resource_ids.join(',') }
    : { date_start: null, resource_ids: null }
}
